import React from 'react';
import styled from 'styled-components';

const CheckBlueIcon = () => {
return(
    <Container>
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.53686 15.9629L9.50148 15.9999L0.666626 6.76348L3.54343 3.75592L9.53698 10.0219L19.1232 0L22 3.00755L9.57236 16L9.53686 15.9629Z"
                fill="#3E73DF"/>
        </svg>
    </Container>
)

}
export default CheckBlueIcon;

const Container = styled.div`

`;